import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-blocks"
export default class extends Controller {
  connect() {
    let mouseDown = false;
    let startX, scrollLeft;
    const slider = this.element

    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      this.element.style.cursor = 'grabbing';
    }

    const stopDragging = (e) => {
      mouseDown = false;
      this.element.style.cursor = 'grab';
    }

    const move = (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    }

    // Add the event listeners
    slider.addEventListener('mousemove', move, false);
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  }
}
